import MuiApartmentIcon from '@material-ui/icons/Apartment';
import MuiBrokenImageIcon from '@material-ui/icons/BrokenImage';
import MuiCategoryIcon from '@material-ui/icons/Category';
import MuiCreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import MuiSubjectIcon from '@material-ui/icons/Subject';
import MuiSearchIcon from '@material-ui/icons/Search';
import MuiChatIcon from '@material-ui/icons/Chat';
import MuiDashboardIcon from '@material-ui/icons/Dashboard';
import MuiDocsIcon from '@material-ui/icons/Description';
import MuiEmailIcon from '@material-ui/icons/Email';
import MuiExtensionIcon from '@material-ui/icons/Extension';
import MuiGitHubIcon from '@material-ui/icons/GitHub';
import MuiHelpIcon from '@material-ui/icons/Help';
import MuiLocationOnIcon from '@material-ui/icons/LocationOn';
import MuiMemoryIcon from '@material-ui/icons/Memory';
import MuiMenuBookIcon from '@material-ui/icons/MenuBook';
import MuiPeopleIcon from '@material-ui/icons/People';
import MuiPersonIcon from '@material-ui/icons/Person';
import MuiWarningIcon from '@material-ui/icons/Warning';
import MuiStorageIcon from '@material-ui/icons/Storage';
import MuiFeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';

const icons = {
  brokenImage: MuiBrokenImageIcon,
  // To be confirmed: see https://github.com/backstage/backstage/issues/4970
  catalog: MuiMenuBookIcon,
  scaffolder: MuiCreateNewFolderIcon,
  techdocs: MuiSubjectIcon,
  search: MuiSearchIcon,
  chat: MuiChatIcon,
  dashboard: MuiDashboardIcon,
  docs: MuiDocsIcon,
  email: MuiEmailIcon,
  github: MuiGitHubIcon,
  group: MuiPeopleIcon,
  help: MuiHelpIcon,
  "kind:api": MuiExtensionIcon,
  "kind:component": MuiMemoryIcon,
  "kind:domain": MuiApartmentIcon,
  "kind:group": MuiPeopleIcon,
  "kind:location": MuiLocationOnIcon,
  "kind:system": MuiCategoryIcon,
  "kind:user": MuiPersonIcon,
  "kind:resource": MuiStorageIcon,
  "kind:template": MuiFeaturedPlayListIcon,
  user: MuiPersonIcon,
  warning: MuiWarningIcon
};

export { icons };
//# sourceMappingURL=icons.esm.js.map
